export default [
    {
        path: 'monitoramento-protocolo',
        component: () => import(
            /* webpackChunkName: 'regulacao-monitoramento-protocolo' */
            '@/views/regulacao/monitoramento-protocolo/Index'
        ),
        redirect: 'monitoramento-protocolo/index',
        children: [
            {
                name: 'regulacao-monitoramento-protocolo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'regulacao-monitoramento-protocolo' */
                    '@/views/regulacao/monitoramento-protocolo/List.vue'
                ),
            },
        ],
    },
]